import {
  CompanyType,
  CreateBrokerField,
  CreateBrokerageField,
  CreateClaimField,
  CreateClaimNoteField,
  CreateClaimantField,
  CreateLicenseField,
  CreateMidtermFiled,
  CreateMidtermTransactionField,
  CreateOfficeField,
  CreateRecoveryField,
  CreateReserveField,
  CreateReservePaymentField,
  CreateSubjectivityField,
  CreateSubmissionField,
  CreateSubsidiaryField,
  CreateTeamsField,
  IQuoteStatus,
  OFACClearanceType,
  PopoverFieldType,
  QuoteEntityFieldIdType,
  QuoteEntityFieldLabelType,
  SortOrder,
  SubmissionFieldIdType,
  SubmissionFilterFieldNameType,
  SubmissionNestedFilterInput,
  SubmissionSortKeys,
  SubmissionStatus,
  SubmissionType,
  UnderwritingSubmissionType,
  Tenant,
} from './app-constants';

import { EndorsementUuid } from './line-item-uuids.enum';

export const SUBMISSION_STATUS_OPTIONS = Object.entries(SubmissionStatus)
  .sort((a, b) => a[1].localeCompare(b[1]))
  .map((submissionStatus) => {
    return {
      value: submissionStatus[1],
      label: submissionStatus[0],
    };
  });

export const UNDERWRITING_SUBMISSION_TYPE_OPTIONS = Object.entries(
  UnderwritingSubmissionType
).map((submissionType) => {
  return {
    value: submissionType[1],
    label: submissionType[0],
  };
});

export const UNDERWRITING_SUBMISSION_RENEWAL_TYPE_OPTIONS = Object.entries(
  SubmissionType
).map((submissionType) => {
  return {
    value: submissionType[0],
    label: submissionType[1],
  };
});

export const DIGITAL_SOURCE_OPTIONS = Object.entries(Tenant)
  .sort((a, b) => a[1].localeCompare(b[1]))
  .map((digitalSource) => {
    return {
      value: digitalSource[1],
      label: digitalSource[0],
    };
  });

export const DEFAULT_UNDERWRITING_SUBMISSION_TYPE =
  UnderwritingSubmissionType.Primary;

export const UNDERWRITING_FILTER_OPTIONS = [
  {
    label: SubmissionFilterFieldNameType.Broker,
    name: SubmissionNestedFilterInput.Broker,
    type: PopoverFieldType.Select,
  },
  {
    label: SubmissionFilterFieldNameType.Brokerage,
    name: SubmissionNestedFilterInput.Brokerage,
    type: PopoverFieldType.Select,
  },
  {
    label: SubmissionFilterFieldNameType.DigitalSource,
    name: SubmissionNestedFilterInput.DigitalSource,
    type: PopoverFieldType.Select,
    options: DIGITAL_SOURCE_OPTIONS,
  },
  {
    label: SubmissionFilterFieldNameType.DueDate,
    name: SubmissionFieldIdType.DueDate,
    type: PopoverFieldType.DateRangePicker,
  },
  {
    label: SubmissionFilterFieldNameType.Partner,
    name: SubmissionFieldIdType.Partner,
    type: PopoverFieldType.Select,
  },
  {
    label: SubmissionFilterFieldNameType.Type,
    name: SubmissionFieldIdType.Type,
    type: PopoverFieldType.Select,
    options: UNDERWRITING_SUBMISSION_TYPE_OPTIONS,
  },

  {
    label: SubmissionFilterFieldNameType.Program,
    name: SubmissionFieldIdType.Program,
    type: PopoverFieldType.Select,
  },

  {
    label: SubmissionFilterFieldNameType.ReceivedAt,
    name: SubmissionFieldIdType.ReceivedAt,
    type: PopoverFieldType.DateRangePicker,
  },

  {
    label: SubmissionFilterFieldNameType.RenewalType,
    name: SubmissionFieldIdType.RenewalType,
    type: PopoverFieldType.Select,
  },
  {
    label: SubmissionFilterFieldNameType.Task,
    name: SubmissionFieldIdType.Task,
    type: PopoverFieldType.Select,
  },
  {
    label: SubmissionFilterFieldNameType.Status,
    name: SubmissionFieldIdType.Status,
    type: PopoverFieldType.Select,
    options: SUBMISSION_STATUS_OPTIONS,
  },
  {
    label: SubmissionFilterFieldNameType.SubmissionType,
    name: SubmissionFieldIdType.submissionType,
    type: PopoverFieldType.Select,
    options: UNDERWRITING_SUBMISSION_RENEWAL_TYPE_OPTIONS,
  },
  {
    label: SubmissionFilterFieldNameType.Underwriter,
    name: SubmissionNestedFilterInput.Underwriter,
    type: PopoverFieldType.Select,
  },
  {
    label: SubmissionFilterFieldNameType.UnderwriterAssistant,
    name: SubmissionNestedFilterInput.UnderwriterAssistant,
    type: PopoverFieldType.Select,
  },
];

export const UNDERWRITING_FILTER_DEFAULTS = {};

export const UNDERWRITING_SORT_DEFAULTS = {
  id: SubmissionSortKeys.CreatedAt,
  order: SortOrder.Desc,
};

export const CREATE_CLAIM_NOTE_LABELS = {
  [CreateClaimNoteField.Note]: '',
  [CreateClaimNoteField.Attachments]: 'Attachments',
  [CreateClaimNoteField.Categories]: 'Categories',
  [CreateClaimNoteField.Folder]: '',
};

export const CREATE_SUBMISSION_FIELD_LABELS = {
  [CreateSubmissionField.AggregateLimit]: 'REQUESTED LIMIT',
  [CreateSubmissionField.BrokerCity]: 'CITY',
  [CreateSubmissionField.BrokerCountryUuid]: 'COUNTRY',
  [CreateSubmissionField.BrokerageUuid]: 'LEGAL NAME',
  [CreateSubmissionField.BrokerPhoneNumber]: 'PHONE NUMBER',
  [CreateSubmissionField.BrokerEmailAddress]: 'EMAIL ADDRESS',
  [CreateSubmissionField.BrokerRegionUuid]: 'REGION',
  [CreateSubmissionField.BrokerStreet1]: 'ADDRESS 1',
  [CreateSubmissionField.BrokerStreet2]: 'ADDRESS 2',
  [CreateSubmissionField.City]: 'CITY',
  [CreateSubmissionField.CountryUuid]: 'COUNTRY',
  [CreateSubmissionField.Domain]: 'DOMAIN',
  [CreateSubmissionField.DueDate]: 'DUE DATE',
  [CreateSubmissionField.LegalName]: 'LEGAL NAME',
  [CreateSubmissionField.TradingName]: 'DBA',
  [CreateSubmissionField.Notes]: 'NOTES',
  [CreateSubmissionField.PolicyEndDate]: 'EXPIRATION DATE',
  [CreateSubmissionField.PolicyRetention]: 'REQUESTED RETENTION',
  [CreateSubmissionField.PolicyRetroactiveDate]:
    'REQUESTED POLICY RETROACTIVE DATE',

  [CreateSubmissionField.PolicyStartDate]: 'EFFECTIVE DATE',
  [CreateSubmissionField.BrokerPostalCode]: 'POSTAL CODE',
  [CreateSubmissionField.PostalCode]: 'POSTAL CODE',
  [CreateSubmissionField.RegionUuid]: 'REGION',
  [CreateSubmissionField.Street1]: 'ADDRESS 1',
  [CreateSubmissionField.Street2]: 'ADDRESS 2',
  [CreateSubmissionField.ProductType]: 'PRODUCT',
  [CreateSubmissionField.ProgramUuid]: 'PROGRAM',
  [CreateSubmissionField.Type]: 'POLICY TYPE',
  [CreateSubmissionField.PartnerUuid]: 'CONVERGE CONNECT™ PARTNER',
  [CreateSubmissionField.ReceivedBy]: 'RECEIVED BY (EMAIL ADDRESS)',
  [CreateSubmissionField.ReceivedAt]: 'DATE RECEIVED',
  [CreateSubmissionField.BrokerAgentUuid]: 'AGENT',
  [CreateSubmissionField.CurrentDomesticRevenue]:
    'DOMESTIC REVENUE CURRENT YEAR',
  [CreateSubmissionField.ProjectDomesticRevenue]: 'DOMESTIC REVENUE PROJECTED',
  [CreateSubmissionField.CurrentForeignRevenue]: 'FOREIGN REVENUE CURRENT YEAR',
  [CreateSubmissionField.ProjectForeignRevenue]: 'FOREIGN REVENUE PROJECTED',
  [CreateSubmissionField.RatedRevenueOverride]: 'RATABLE REVENUE',
  [CreateSubmissionField.ContactFirstName]: 'CONTACT FIRST NAME',
  [CreateSubmissionField.ContactLastName]: 'CONTACT LAST NAME',
  [CreateSubmissionField.ContactEmailAddress]: 'CONTACT EMAIL ADDRESS',
  [CreateSubmissionField.EstablishedYear]: 'YEAR ESTABLISHED',
  [CreateSubmissionField.ContactPhoneNumber]: 'CONTACT PHONE NUMBER',
  [CreateSubmissionField.Designation]: 'DESIGNATION',
  [CreateSubmissionField.IndustrySector]: 'INDUSTRY SECTOR (NAICS)',
  [CreateSubmissionField.ClearanceNote]: 'Clearance Note',
  [CreateSubmissionField.ClearanceStatus]: 'Clearance Status',
  [CreateSubmissionField.NumEmployees]: 'EMPLOYEES',
  [CreateSubmissionField.Status]: 'STATUS',
  [CreateSubmissionField.Attachments]: 'ATTACHMENTS',
  [CreateSubmissionField.UserUuid]: 'UNDERWRITER',
};

export const CREATE_BROKERAGE_FIELD_LABELS = {
  [CreateBrokerageField.BusinessDevelopmentManager]:
    'BUSINESS DEVELOPMENT MANAGER',
  [CreateBrokerageField.Underwriter]: 'UNDERWRITER',
  [CreateBrokerageField.UwRegion]: 'UW REGION',
  [CreateBrokerageField.BdmRegion]: 'BDM REGION',
  [CreateBrokerageField.PrimaryContactUuid]: 'PRIMARY CONTACT',
  [CreateBrokerageField.PrimaryContactEmail]: 'PRIMARY CONTACT EMAIL',
  [CreateBrokerageField.CompanyName]: 'COMPANY NAME',
  [CreateBrokerageField.DbaName]: 'DBA NAME',
  [CreateBrokerageField.Domain]: 'DOMAIN',
  [CreateBrokerageField.GlobalParentCompany]: 'PARENT ENTITY',
  [CreateBrokerageField.PartnerEntity]: 'PARTNER ENTITY',
  [CreateBrokerageField.Fein]: 'FEIN',
  [CreateBrokerageField.Npn]: 'NPN',
  [CreateBrokerageField.ProgramUuid]: 'PROGRAM',
  [CreateBrokerageField.CoverageRegionUuid]: 'UNDERWRITING REGION',
  [CreateBrokerageField.PrimaryStreet1]: 'PRIMARY ADDRESS 1',
  [CreateBrokerageField.PrimaryStreet2]: 'PRIMARY ADDRESS 2',
  [CreateBrokerageField.PrimaryCity]: 'CITY',
  [CreateBrokerageField.PrimaryRegionUuid]: 'STATE',
  [CreateBrokerageField.PrimaryPostalCode]: 'POSTAL/ZIP CODE',
  [CreateBrokerageField.PrimaryCountryUuid]: 'COUNTRY',
  [CreateBrokerageField.PrimaryPhoneNumber]: 'PRIMARY BROKERAGE PHONE',
  [CreateBrokerageField.PrimaryPhoneNumberExtn]: '',
  [CreateBrokerageField.Street1]: 'ADDRESS 1',
  [CreateBrokerageField.Street2]: 'ADDRESS 2',
  [CreateBrokerageField.City]: 'CITY',
  [CreateBrokerageField.RegionUuid]: 'STATE',
  [CreateBrokerageField.PostalCode]: 'POSTAL/ZIP CODE',
  [CreateBrokerageField.CountryUuid]: 'COUNTRY',

  [CreateBrokerageField.Wholesale]: '',
  [CreateBrokerageField.Digital]: '',
};

export const CREATE_SUBJECTIVITY_FIELD_LABELS = {
  [CreateSubjectivityField.customSubjectivityNameField]: '',
};

export const CREATE_SUBSIDIARY_FIELD_LABELS = {
  [CreateSubsidiaryField.LegalName]: 'LEGAL NAME',
  [CreateSubsidiaryField.DbaName]: 'DBA NAME',
  [CreateSubsidiaryField.Domain]: 'DOMAIN',
  [CreateSubsidiaryField.Fein]: 'FEIN',
  [CreateSubsidiaryField.Npn]: 'NPN',
  [CreateSubsidiaryField.ProgramUuid]: 'PROGRAM',
  [CreateSubsidiaryField.Region]: 'REGION (CONVERGE DESIGNATION',
  [CreateSubsidiaryField.OfficeName]: 'OFFICE NAME (OR CITY)',
  [CreateSubsidiaryField.BrokerTeamName]: 'BROKER TEAM NAME',
  [CreateSubsidiaryField.Address1]: 'ADDRESS 1',
  [CreateSubsidiaryField.Address2]: 'ADDRESS 2',
  [CreateSubsidiaryField.City]: 'CITY',
  [CreateSubsidiaryField.RegionUuid]: 'STATE',
  [CreateSubsidiaryField.PostalCode]: 'POSTAL/ZIP CODE',
  [CreateSubsidiaryField.CountryUuid]: 'COUNTRY',
  [CreateSubsidiaryField.PrimaryContactFirstName]: 'PRIMARY CONTACT FIRST NAME',
  [CreateSubsidiaryField.PrimaryContactLastName]: 'PRIMARY CONTACT LAST NAME',
  [CreateSubsidiaryField.Email]: 'EMAIL',
  [CreateSubsidiaryField.MobilePhoneNumber]: 'MOBILE NUMBER',
  [CreateSubsidiaryField.OfficePhoneNumber]: 'OFFICE NUMBER',
};

export const CREATE_BROKER_FIELD_LABELS = {
  [CreateBrokerField.BusinessDevelopmentManager]:
    'BUSINESS DEVELOPMENT MANAGER',
  [CreateBrokerField.Underwriter]: 'UNDERWRITER',
  [CreateBrokerField.UwRegion]: 'UW REGION',
  [CreateBrokerField.BdmRegion]: 'BDM REGION',
  [CreateBrokerField.FirstName]: 'FIRST NAME',
  [CreateBrokerField.LastName]: 'LAST NAME',
  [CreateBrokerField.BrokerTitle]: 'BROKER TITLE',
  [CreateBrokerField.Ssn]: 'LAST 4 DIGITS OF SSN',
  [CreateBrokerField.Npn]: 'NPN',
  [CreateBrokerField.GlobalParent]: 'BROKERAGE',
  [CreateBrokerField.Office]: 'OFFICE',
  [CreateBrokerField.BrokerTeam]: 'BROKER TEAM',
  [CreateBrokerField.Email]: 'PRIMARY EMAIL',
  [CreateBrokerField.SecondaryEmail]: 'ADDITIONAL EMAIL',
  [CreateBrokerField.TertiaryEmail]: 'ADDITIONAL EMAIL',
  [CreateBrokerField.MobilePhoneNumber]: 'MOBILE NUMBER',
  [CreateBrokerField.MobilePhoneNumberExtn]: '',
  [CreateBrokerField.OfficePhoneNumber]: 'OFFICE NUMBER',
  [CreateBrokerField.OfficePhoneNumberExtn]: '',
  [CreateBrokerField.Address1]: 'ADDRESS 1',
  [CreateBrokerField.Address2]: 'ADDRESS 2',
  [CreateBrokerField.City]: 'CITY',
  [CreateBrokerField.RegionUuid]: 'STATE',
  [CreateBrokerField.PostalCode]: 'POSTAL/ZIP CODE',
  [CreateBrokerField.CountryUuid]: 'COUNTRY',
};
export const CREATE_CLAIM_FIELD_LABELS = {
  [CreateClaimField.Description]: 'Description',
  [CreateClaimField.DiscoveryDate]: 'Discovery Date',
  [CreateClaimField.JiraId]: 'JiraId',
  [CreateClaimField.PolicyUuid]: 'Policy',
  [CreateClaimField.ReferenceId]: 'Reference',
  [CreateClaimField.ReportedDate]: 'Reported Date',
  [CreateClaimField.StartDate]: 'Start Date',
  [CreateClaimField.Status]: 'Status',
  [CreateClaimField.DueDate]: 'Due Date',
  [CreateClaimField.coverageLetter]: 'Cover letter',
  [CreateClaimField.documentLink]: 'document Link',
};

export const CREATE_MIDTERM_FIELD_LABELS = {
  [CreateMidtermFiled.midtermTransaction]: 'MIDTERM TRANSACTION',
};

export const CREATE_MIDTERM_TRANSACTION_FIELD_LABELS = {
  [CreateMidtermTransactionField.cancellationType]: 'CANCELLATION TYPE',
  [CreateMidtermTransactionField.refundType]: 'REFUND TYPE',
  [CreateMidtermTransactionField.startDate]: '',
  [CreateMidtermTransactionField.notes]: '',
  [CreateMidtermTransactionField.LegalName]: 'LEGAL NAME OF ACQUIRING ENTITY',
  [CreateMidtermTransactionField.DateOfAcquisition]: 'DATE OF ACQUISITION',
  [CreateMidtermTransactionField.NewBrokerUuid]: '',
  [CreateMidtermTransactionField.NewBrokerName]: '',
  [CreateMidtermTransactionField.NewBrokerageName]: '',
  [CreateMidtermTransactionField.NewBrokerageAddress]: '',
  [CreateMidtermTransactionField.NewBrokerageUuid]: '',
};

export const CREATE_RESERVE_FIELD_LABELS = {
  [CreateReserveField.ClaimUuid]: 'Claim',
  [CreateReserveField.VendorUuid]: 'Vendor',
  [CreateReserveField.ReserveTypeUuid]: 'Reserve Type',
  [CreateReserveField.ReserveUuid]: 'Reserve',
  [CreateReserveField.CoverageUuid]: 'Coverage',
  [CreateReserveField.ServiceUuid]: 'Service',
  [CreateReserveField.BudgetType]: 'Budget Type',
  [CreateReserveField.Budget]: 'Budget',
  [CreateReserveField.BudgetMax]: 'Budget Max',
  [CreateReserveField.BudgetMin]: 'Budget Min',
};

export const CREATE_LICENSE_FIELD_LABELS = {
  [CreateLicenseField.LicenseTypeUuid]: 'LICENSE TYPE',
  [CreateLicenseField.LicenseNumber]: 'LICENSE NUMBER',
  [CreateLicenseField.LicenseRegionUuid]: 'STATE',
  [CreateLicenseField.LicenseExpirationDate]: 'EXPIRATION DATE',
  [CreateLicenseField.Uuid]: '',
  [CreateLicenseField.LicenseHolderUuid]: 'LICENSE HOLDER',
  [CreateLicenseField.perpetual]: '',
};

export const CREATE_CLAIMANT_FIELD_LABELS = {
  [CreateClaimantField.FirstName]: 'FIRST NAME',
  [CreateClaimantField.LastName]: 'LAST NAME',
  [CreateClaimantField.CompanyName]: 'COMPANY NAME',
  [CreateClaimantField.Email]: 'EMAIL',
  [CreateClaimantField.PrimaryPhoneNumber]: 'PRIMARY PHONE',
  [CreateBrokerageField.PrimaryPhoneNumberExtn]: '',
  [CreateClaimantField.Address1]: 'ADDRESS 1',
  [CreateClaimantField.Address2]: 'ADDRESS 2',
  [CreateClaimantField.City]: 'CITY',
  [CreateClaimantField.CountryUuid]: 'COUNTRY',
  [CreateClaimantField.RegionUuid]: 'STATE',
  [CreateClaimantField.PostalCode]: 'POSTAL/ZIP CODE',
  [CreateClaimantField.isInsured]: '',
};

export const CREATE_TEAM_FIELD_LABELS = {
  [CreateTeamsField.BusinessDevelopmentManager]: 'BUSINESS DEVELOPMENT MANAGER',
  [CreateTeamsField.BDMRegion]: 'BDM REGION',
  [CreateTeamsField.Underwriter]: 'UNDERWRITER',
  [CreateTeamsField.PrimaryContactUuid]: 'PRIMARY CONTACT',
  [CreateTeamsField.PrimaryContactEmail]: 'PRIMARY CONTACT EMAIL',
  [CreateTeamsField.Uuid]: '',
  [CreateTeamsField.TeamName]: 'TEAM NAME',
  [CreateTeamsField.UwRegion]: 'UW REGION',
  [CreateTeamsField.PrimaryContact]: 'PRIMARY CONTACT',
};

export const CREATE_RECOVERY_FIELD_LABELS = {
  [CreateRecoveryField.RecoveryType]: 'RECOVERY TYPE',
  [CreateRecoveryField.AmountAnticipated]: 'AMOUNT ANTICIPATED',
};

export const CREATE_OFFICE_FIELD_LABELS = {
  [CreateBrokerField.BusinessDevelopmentManager]:
    'BUSINESS DEVELOPMENT MANAGER',
  [CreateOfficeField.Underwriter]: 'UNDERWRITER',
  [CreateOfficeField.UwRegion]: 'UW REGION',
  [CreateOfficeField.PrimaryContactUuid]: 'PRIMARY CONTACT',
  [CreateOfficeField.PrimaryContactEmail]: 'PRIMARY CONTACT EMAIL',
  [CreateOfficeField.AddressUuid]: 'Address',
  [CreateOfficeField.Name]: 'OFFICE NAME',
  [CreateOfficeField.OfficeUuid]: 'STATE',

  [CreateOfficeField.AppendUwTerritories]: '',
  [CreateOfficeField.Street1]: 'ADDRESS 1',
  [CreateOfficeField.Street2]: 'ADDRESS 2',
  [CreateOfficeField.City]: 'CITY',
  [CreateOfficeField.RegionUuid]: 'STATE',
  [CreateOfficeField.PostalCode]: 'POSTAL/ZIP CODE',
  [CreateOfficeField.CountryUuid]: 'COUNTRY',
  [CreateOfficeField.useCorpAddress]: '',
  [CreateOfficeField.BdmTerritoryUuids]: 'BDM REGION',
};

export const getCreateClaimNoteFieldLabel = (
  field: CreateClaimNoteField
): string => {
  return CREATE_CLAIM_NOTE_LABELS[field] ?? field;
};

export const getCreateClaimNoteFieldProps = (
  field: CreateClaimNoteField
): { name: string; label: string; containerWidth: number } => {
  return {
    name: field,
    label: getCreateClaimNoteFieldLabel(field),
    containerWidth: 4,
  };
};

export const getCreateSubmissionFieldLabel = (
  field: CreateSubmissionField
): string => {
  return CREATE_SUBMISSION_FIELD_LABELS[field] ?? field;
};

export const getCreateSubmissionFieldProps = (
  field: CreateSubmissionField,
  ReginName?: string
): { name: string; label: string; containerWidth: number } => {
  return {
    name: field,
    label:
      field === 'regionUuid'
        ? ReginName ?? ''
        : getCreateSubmissionFieldLabel(field),
    containerWidth: 4,
  };
};

export function capitalizeFirstLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const getCreateClaimantFieldLabel = (
  field: CreateClaimantField
): string => {
  return CREATE_CLAIMANT_FIELD_LABELS[field] ?? field;
};

export const getCreateClaimantFieldProps = (
  field: CreateClaimantField
): { name: string; label: string; containerWidth: number } => {
  return {
    name: field,
    label: getCreateClaimantFieldLabel(field),
    containerWidth: 4,
  };
};

export const getCreateLicenseFieldLabel = (
  field: CreateLicenseField
): string => {
  return CREATE_LICENSE_FIELD_LABELS[field] ?? field;
};

export const getCreateLicenseFieldProps = (
  field: CreateLicenseField
): { name: string; label: string; containerWidth: number } => {
  return {
    name: field,
    label: getCreateLicenseFieldLabel(field),
    containerWidth: 4,
  };
};
export const getCreateTeamFieldLabel = (field: CreateTeamsField): string => {
  return CREATE_TEAM_FIELD_LABELS[field] ?? field;
};

export const getCreateTeamFieldProps = (
  field: CreateTeamsField
): { name: string; label: string; containerWidth: number } => {
  return {
    name: field,
    label: getCreateTeamFieldLabel(field),
    containerWidth: 4,
  };
};

export const getCreateRecoveryFieldLabel = (
  field: CreateRecoveryField
): string => {
  return CREATE_RECOVERY_FIELD_LABELS[field] ?? field;
};

export const getCreateRecoveryFieldProps = (
  field: CreateRecoveryField
): { name: string; label: string; containerWidth: number } => {
  return {
    name: field,
    label: getCreateRecoveryFieldLabel(field),
    containerWidth: 4,
  };
};

export const getCreateOfficeFieldLabel = (field: CreateOfficeField): string => {
  return CREATE_OFFICE_FIELD_LABELS[field] ?? field;
};

export const getCreateOfficeFieldProps = (
  field: CreateOfficeField
): { name: string; label: string; containerWidth: number } => {
  return {
    name: field,
    label: getCreateOfficeFieldLabel(field),
    containerWidth: 4,
  };
};

export const getCreateBrokerageFieldLabel = (
  field: CreateBrokerageField
): string => {
  return CREATE_BROKERAGE_FIELD_LABELS[field] ?? field;
};

export const getCreateBrokerageFieldProps = (
  field: CreateBrokerageField
): { name: string; label: string; containerWidth: number } => {
  return {
    name: field,
    label: getCreateBrokerageFieldLabel(field),
    containerWidth: 4,
  };
};

export const getCreateSubjectivityFieldLabel = (
  field: CreateSubjectivityField
): string => {
  return CREATE_SUBJECTIVITY_FIELD_LABELS[field] ?? field;
};

export const getCreateSubjectivityFieldProps = (
  field: CreateSubjectivityField
): { name: string; label: string; containerWidth: number } => {
  return {
    name: field,
    label: getCreateSubjectivityFieldLabel(field),
    containerWidth: 4,
  };
};

export const getCreateSubsidiaryFieldLabel = (
  field: CreateSubsidiaryField
): string => {
  return CREATE_SUBSIDIARY_FIELD_LABELS[field] ?? field;
};

export const getCreateSubsidiaryProps = (
  field: CreateSubsidiaryField
): { name: string; label: string; containerWidth: number } => {
  return {
    name: field,
    label: getCreateSubsidiaryFieldLabel(field),
    containerWidth: 4,
  };
};

export const getCreateBrokerFieldLabel = (field: CreateBrokerField): string => {
  return CREATE_BROKER_FIELD_LABELS[field] ?? field;
};

export const getCreateBrokerFieldProps = (
  field: CreateBrokerField
): { name: string; label: string; containerWidth: number } => {
  return {
    name: field,
    label: getCreateBrokerFieldLabel(field),
    containerWidth: 4,
  };
};

export const getCreateClaimFieldLabel = (field: CreateClaimField): string => {
  return CREATE_CLAIM_FIELD_LABELS[field] ?? field;
};

export const getCreateClaimFieldProps = (
  field: CreateClaimField
): { name: string; label: string; containerWidth: number } => {
  return {
    name: field,
    label: getCreateClaimFieldLabel(field),
    containerWidth: 4,
  };
};

export const getMidtermFieldLabel = (field: CreateMidtermFiled): string => {
  return CREATE_MIDTERM_FIELD_LABELS[field] ?? field;
};

export const getMidtermFieldProps = (
  field: CreateMidtermFiled
): { name: string; label: string; containerWidth: number } => {
  return {
    name: field,
    label: getMidtermFieldLabel(field),
    containerWidth: 4,
  };
};

export const getMidtermTransactionFieldLabel = (
  field: CreateMidtermTransactionField
): string => {
  return CREATE_MIDTERM_TRANSACTION_FIELD_LABELS[field] ?? field;
};

export const getMidtermTransactionFieldProps = (
  field: CreateMidtermTransactionField
): { name: string; label: string; containerWidth: number } => {
  return {
    name: field,
    label: getMidtermTransactionFieldLabel(field),
    containerWidth: 4,
  };
};

export const getCreateReservePaymentFieldProps = (
  field: CreateReservePaymentField
): { name: string; label: string; containerWidth: number } => {
  return {
    name: field,
    label: '',
    containerWidth: 4,
  };
};
export const getFieldProps = (
  name: string,
  isDisabled = false,
  label: string,
  isReadonly?: boolean
): { name: string; label: string; disabled: boolean; isReadonly?: boolean } => {
  return {
    name: name,
    label: label,
    disabled: isDisabled,
    isReadonly: isReadonly,
  };
};

export const getSubmissionFieldRequiredErrorMessage = (): string => {
  return `This field is required`;
};

export const getSubmissionFieldWrongTypeErrorMessage = (
  field: CreateSubmissionField
): string => {
  return `${CREATE_SUBMISSION_FIELD_LABELS[field]} is the wrong type`;
};

export const getLicenseFieldWrongTypeErrorMessage = (
  field: CreateLicenseField
): string => {
  return `${CREATE_LICENSE_FIELD_LABELS[
    field
  ].toLowerCase()} is the wrong type`;
};

export const getOfficeFieldWrongTypeErrorMessage = (
  field: CreateOfficeField
): string => {
  return `${CREATE_OFFICE_FIELD_LABELS[field].toLowerCase()} is the wrong type`;
};

export const getOfficeFieldRequiredErrorMessage = (): string => {
  return `This field is required`;
};

export const getBrokerFieldWrongTypeErrorMessage = (
  field: CreateBrokerField
): string => {
  return `${CREATE_BROKER_FIELD_LABELS[field].toLowerCase()} is the wrong type`;
};
export const getBrokerFieldRequiredErrorMessage = (): string => {
  return `This field is required`;
};

export const getClaimFieldRequiredErrorMessage = (): string => {
  return `This field is required`;
};

export const getGenericFieldRequiredErrorMessage = (): string => {
  return `This field is required`;
};

export const getMidtermTransactionWrongTypeErrorMessage = (
  field: CreateMidtermTransactionField
): string => {
  return `${CREATE_MIDTERM_TRANSACTION_FIELD_LABELS[field]} is the wrong type`;
};

export const getClaimFieldWrongTypeErrorMessage = (
  field: CreateClaimField
): string => {
  return `${CREATE_CLAIM_FIELD_LABELS[field]} is the wrong type`;
};

export const getReserveFieldWrongTypeErrorMessage = (
  field: CreateReserveField
): string => {
  return `${CREATE_RESERVE_FIELD_LABELS[field]} is the wrong type`;
};

export const getReserveFieldRequiredErrorMessage = (
  field: CreateReserveField
): string => {
  return `${CREATE_RESERVE_FIELD_LABELS[field]}`;
};

export const getBrokerageFieldRequiredErrorMessage = (): string => {
  return 'This field is required';
};
export const getBrokerageFieldRequiredErrorMessageforAddress = (
  field: string
): string => {
  const addressFields = ['primaryAddress1', 'address1'];
  const cityFields = ['primaryCity', 'city'];
  const stateFields = ['primaryRegionUuid', 'regionUuid', 'RegionUuid'];
  const postalFields = ['primaryPostalCode', 'postalCode'];
  if (addressFields.includes(field)) return 'Please enter a valid street';
  if (cityFields.includes(field)) return 'Please enter a valid city';
  if (stateFields.includes(field)) return 'Please enter a valid state';
  if (postalFields.includes(field))
    return 'Please enter a valid postal/zip code';
  return 'Please enter a valid address';
};
export const getBrokerageFieldWrongTypeErrorMessage = (
  field: CreateBrokerageField
): string => {
  return `${CREATE_BROKERAGE_FIELD_LABELS[
    field
  ].toLowerCase()} is the wrong type`;
};

export enum UnderwritingSubmissionDetailPageSlug {
  Overview = 'overview',
  Questionnaire = 'questionnaire',
  RiskProfile = 'risk-profile',
  Quote = 'quote',
  Subjectivities = 'subjectivities',
  Bind = 'bind',
  Policy = 'policy',
}

export enum UnderwritingSubmissionDetailRaterPageViewSlug {}

export const UNDERWRITING_SUBMISSION_DETAIL_MENU_ITEMS = [
  {
    label: 'Overview',
    value: UnderwritingSubmissionDetailPageSlug.Overview,
  },
  {
    label: 'Questionnaire',
    value: UnderwritingSubmissionDetailPageSlug.Questionnaire,
  },
  {
    label: 'Risk Profile',
    value: UnderwritingSubmissionDetailPageSlug.RiskProfile,
  },
  {
    label: 'Quote',
    value: UnderwritingSubmissionDetailPageSlug.Quote,
  },
  {
    label: 'Bind',
    value: UnderwritingSubmissionDetailPageSlug.Bind,
  },
  {
    label: 'Policy',
    value: UnderwritingSubmissionDetailPageSlug.Policy,
  },
];

export enum ClaimEntityDetailPageSlug {
  InsuredOverview = 'overview',
  ClaimDetails = 'details',
  Financials = 'financials',
  Contacts = 'contacts',
  Policy = 'policy',
  Diary = 'diary',
  Notes = 'notes',
  Reports = 'reports',
  Documents = 'documents',
  HistoryLog = 'historyLog',
}

export const CLAIM_ENTITY_DETAIL_MENU_ITEMS = [
  {
    label: 'Claim Information',
    value: ClaimEntityDetailPageSlug.ClaimDetails,
    icon: 'InventoryBox',
  },
  {
    label: 'Diary',
    value: ClaimEntityDetailPageSlug.Diary,
    icon: 'CheckList',
  },
  {
    label: 'Notes',
    value: ClaimEntityDetailPageSlug.Notes,
    icon: 'Notes',
  },
  {
    label: 'Financials',
    value: ClaimEntityDetailPageSlug.Financials,
    icon: 'Financials',
  },
  {
    label: 'Contacts',
    value: ClaimEntityDetailPageSlug.Contacts,
    icon: 'Contacts',
  },
  {
    label: 'Insured Overview',
    value: ClaimEntityDetailPageSlug.InsuredOverview,
    icon: 'HomeWorkIcon',
  },
  {
    label: 'Reports',
    value: ClaimEntityDetailPageSlug.Reports,
    icon: 'Assessment',
  },

  {
    label: 'Documents',
    value: ClaimEntityDetailPageSlug.Documents,
    icon: 'Folder',
  },
  {
    label: 'History Log',
    value: ClaimEntityDetailPageSlug.HistoryLog,
    icon: 'Inventory',
  },
];

export enum InsuredEntityDetailPageSlug {
  Overview = 'overview',

  Policies = 'policies',
  Reports = 'reports',
  Documents = 'documents',
}

export const INSURED_ENTITY_DETAIL_MENU_ITEMS = [
  {
    label: 'Overview',
    value: InsuredEntityDetailPageSlug.Overview,
    icon: 'Overview',
  },
  // {
  //   label: 'Documents',
  //   value: InsuredEntityDetailPageSlug.Documents,
  // },
  // {
  //   label: 'Submissions',
  //   value: InsuredEntityDetailPageSlug.Submissions,
  // },
  // {
  //   label: 'Associated brokers',
  //   value: InsuredEntityDetailPageSlug.AssociatedBrokers,
  // },
  // {
  //   label: 'Quotes',
  //   value: InsuredEntityDetailPageSlug.Quotes,
  // },
  {
    label: 'Policies',
    value: InsuredEntityDetailPageSlug.Policies,
    icon: 'Policies',
  },
  {
    label: 'Reports',
    value: InsuredEntityDetailPageSlug.Reports,
    icon: 'Reports',
  },
  {
    label: 'Documents',
    value: InsuredEntityDetailPageSlug.Documents,
    icon: 'Documents',
  },
];

export enum BrokerAgencyEntityDetailPageSlug {
  Overview = 'overview',
  Agents = 'agents',
  Insureds = 'insureds',
  Submissions = 'submissions',
  Quotes = 'quotes',
  Policies = 'policies',
}

export const BROKER_AGENCY_ENTITY_DETAIL_MENU_ITEMS = [
  {
    label: 'Overview',
    value: BrokerAgencyEntityDetailPageSlug.Overview,
  },

  {
    label: 'Agents',
    value: BrokerAgencyEntityDetailPageSlug.Agents,
  },
  {
    label: 'Insureds',
    value: BrokerAgencyEntityDetailPageSlug.Insureds,
  },
  {
    label: 'Submissions',
    value: BrokerAgencyEntityDetailPageSlug.Submissions,
  },
  {
    label: 'Quotes',
    value: BrokerAgencyEntityDetailPageSlug.Quotes,
  },
  {
    label: 'Policies',
    value: BrokerAgencyEntityDetailPageSlug.Policies,
  },
];

export enum QuoteEntityDetailPageSlug {
  Overview = 'overview',
  Policies = 'policies',
  Submissions = 'submissions',
}

export const QUOTE_ENTITY_DETAIL_MENU_ITEMS = [
  {
    label: 'Overview/summary',
    value: QuoteEntityDetailPageSlug.Overview,
  },
  {
    label: 'Policies',
    value: QuoteEntityDetailPageSlug.Policies,
  },
  {
    label: 'Submissions',
    value: QuoteEntityDetailPageSlug.Submissions,
  },
];

export enum PolicyEntityDetailPageSlug {
  Overview = 'overview',
}

export const POLICY_ENTITY_DETAIL_MENU_ITEMS = [
  {
    label: 'Overview',
    value: PolicyEntityDetailPageSlug.Overview,
  },
];

export const COMPANY_TYPE_OPTIONS = Object.entries(CompanyType).map(
  (submissionType) => {
    return {
      value: submissionType[0],
      label: submissionType[1],
    };
  }
);

export const OFAC_CLEARANCE_TYPE_OPTIONS = Object.entries(
  OFACClearanceType
).map((submissionType) => {
  return {
    value: submissionType[0],
    label: submissionType[1],
  };
});

export enum ProductType {
  ConvergeElements = '5cfa4760-73f9-4008-b760-6cac23df5537',
  TechEO = 'Tech E&O',
  Mpl = 'MPL',
}

export const DEFAULT_PRODUCT_TYPE = ProductType.ConvergeElements;

export const PRODUCT_TYPE_OPTIONS = [
  {
    value: ProductType.ConvergeElements,
    label: 'ConvergeElements™',
  },
  {
    value: ProductType.TechEO,
    label: 'Tech E&O',
  },
  {
    value: ProductType.Mpl,
    label: 'MPL',
  },
];

export enum PartnerType {
  QbeNorthAmerica = '53712328-028a-4631-bb7b-bf9252c15f6f',
}

export const DEFAULT_CAPACITY_PROVIDER_TYPE = PartnerType.QbeNorthAmerica;

export const PARTNER_TYPE_OPTIONS = [
  {
    value: PartnerType.QbeNorthAmerica,
    label: 'QBE North America',
  },
];

export enum ProgramType {
  SmeUnder100M = 'c448e5af-8132-458f-a712-311469e273c1',
}

export const DEFAULT_PROGRAM_TYPE = ProgramType.SmeUnder100M;

export const PROGRAM_TYPE_OPTIONS = [
  {
    value: ProgramType.SmeUnder100M,
    label: 'SME <$100M',
  },
];

export function toTitleCase(str: string) {
  return str.replace(/_/gm, ' ').replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

export const QUOTE_STATUS_OPTIONS = Object.entries(IQuoteStatus).map(
  (submissionType) => {
    return {
      value: submissionType[1],
      label: submissionType[0],
    };
  }
);

export const QUOTES_FILTER_OPTIONS = [
  {
    label: QuoteEntityFieldLabelType.Status,
    name: QuoteEntityFieldIdType.Status,
    type: PopoverFieldType.Select,
    options: QUOTE_STATUS_OPTIONS,
  },
];

export const QUOTES_FILTER_DEFAULTS = {};

export const QUOTES_SORT_DEFAULTS = {
  id: QuoteEntityFieldIdType.UpdatedAt,
  order: SortOrder.Desc,
};

export const QUOTE_TYPE_OPTIONS = [
  {
    value: 'DEFAULT_QUOTE',
    label: 'Default Quote',
  },
  {
    value: 'USER_QUOTE',
    label: 'User Quote',
  },
];

export const POLICY_STATUS_OPTIONS = [
  {
    value: 'DRAFT',
    label: 'Draft',
  },
  {
    value: 'OBSOLETE',
    label: 'Obsolete',
  },
];

export const TEMP_ENDORSEMENT_SIMILAR_PREMIUM_BEARING: string[] = [
  EndorsementUuid.RansomwareEventSublimit,
];
